import React from "react";

const AdminHoursComponent = props => {

    return(
   <>
       AdminHoursComponent
    </>
    );
}

AdminHoursComponent.defaultProps = {

}
AdminHoursComponent.propTypes = {

}

export default (AdminHoursComponent);